import React from 'react'
import FormDropdown from './FormDropdown'
import AgentsDropdown from './AgentsDropdown'
import { BasicButton } from '../components'

export default function ResponsesTopBar({setSelectedAgents, setSelectedForms, selectedAgents=[], selectedForms=[]}) {


    return (
        <div className=' flex flex-1 gap-6 items-center'>
            <FormDropdown valueUpdater={setSelectedForms} defaultValue={selectedForms} isMultiple  />
            <AgentsDropdown valueUpdater={setSelectedAgents} defaultValue={selectedAgents} />
        </div>
    )
}
